import Workshop from "../../views/modules/workshop/Workshop";
import CustomerList from "../../views/modules/workshop/customers/CustomerList";
import ReceptionList from "../../views/modules/workshop/receptions/ReceptionList";
import DocumentList from "../../views/modules/workshop/documents/DocumentList";
import Test1List from "../../views/modules/workshop/test_1/Test1List";
import RepairList from "../../views/modules/workshop/repair/RepairList";
import Test2List from "../../views/modules/workshop/test_2/Test2List";
import QAList from "../../views/modules/workshop/qa/QAList";
import DepartureList from "../../views/modules/workshop/departures/DepartureList";
import CountrieList from "../../views/modules/workshop/maintenances/countries/CountrieList";
import ReasonList from "../../views/modules/workshop/maintenances/reasons/ReasonList";
import RepairRatioList from "../../views/modules/workshop/maintenances/repair_ratio/RepairRatioList";
// reports
import IngenicoList from "../../views/modules/workshop/reports/ingenico/IngenicoList";

import layouts from "../../layout";

export default {
  path: "/workshop",
  name: "workshop",
  component: Workshop,
  meta: {
    auth: true
  },
  redirect: {
    name: "workshop-customers"
  },
  children: [
    {
      path: "customers",
      name: "workshop-customers",
      component: CustomerList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Customers",
        tags: ["workshop", "customers"]
      }
    },
    {
      path: "documents",
      name: "sales-documents",
      component: DocumentList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Document",
        tags: ["workshop", "documents"],
        index: true
      }
    },
    {
      path: "receptions",
      name: "workshop-receptions",
      component: ReceptionList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Receptions",
        tags: ["workshop", "receptions"]
      }
    },
    {
      path: "test1",
      name: "workshop-test1",
      component: Test1List,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Test1",
        tags: ["workshop", "test1"]
      }
    },
    {
      path: "repair",
      name: "workshop-repair",
      component: RepairList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Repair",
        tags: ["workshop", "repair"]
      }
    },
    {
      path: "test2",
      name: "workshop-test2",
      component: Test2List,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Test2",
        tags: ["workshop", "test2"]
      }
    },
    {
      path: "qa",
      name: "workshop-qa",
      component: QAList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "QA",
        tags: ["workshop", "qa"]
      }
    },
    {
      path: "departures",
      name: "workshop-departure",
      component: DepartureList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Departures",
        tags: ["workshop", "departure"]
      }
    },
    {
      path: "maintenances/countries",
      name: "workshop-maintenance-countries",
      component: CountrieList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Countrie",
        tags: ["workshop", "maintenances", "countrie"]
      }
    },
    {
      path: "maintenances/reasons",
      name: "workshop-maintenance-reason",
      component: ReasonList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Reasons",
        tags: ["workshop", "maintenances", "reasons"]
      }
    },
    {
      path: "maintenances/repair_ratio",
      name: "workshop-maintenance-repair-ratio",
      component: RepairRatioList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Repair Ratio",
        tags: ["workshop", "maintenances", "repairRatio"]
      }
    },
    {
      path: "reports/ingenico",
      name: "workshop-reports-ingenico",
      component: IngenicoList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Reporte Ingenico",
        tags: ["workshop", "reports", "ingenico"]
      }
    }
  ]
};
